<template>
    <el-card class="doc-card" shadow="never">
        <template #header>
            <div class="doc-card__head" @click="viewCollected">
                <span class="doc-card__name">{{ data.name }}</span>
                <span class="doc-card__count">{{ data.docCount }} 篇</span>
            </div>
        </template>
        <ul class="doc-card__list">
            <li v-for="doc in data.docLites" :key="doc.id" class="doc-card__item" @click="viewDoc(doc.id)">
                <span class="doc-card__title">{{ ellipsis(doc.title) }}</span>
                <span class="doc-card__time">{{ doc.relativeUpdateTime }}</span>
            </li>
        </ul>
    </el-card>
</template>

<script>
export default {
    props: {
        data: Object
    },
    methods: {
        ellipsis(value) {
            let textLength = 30;
            if (!value) return '';
            if (value.length > textLength) {
                return value.slice(0, textLength) + '...';
            }
            return value;
        },
        viewCollected() {
            this.$router.push({ name: 'collected', params: { collectedId: this.data.id, docId: '_intro' } });
        },
        viewDoc(id) {
            this.$router.push({ name: 'collected', params: { collectedId: this.data.id, docId: id } });
        }
    }
};
</script>

<style lang="scss" scoped>
.doc-card {
    /* 变量由父级 .preview-page 提供，单独使用时的兜底值 */
    --pv-line: #e6eaf0;

    /* 工作台等页面的样式块未加 scoped，会全局注入 .el-card{margin:10px} 且卸载后仍生效，
       这里显式清零，保证卡片间距不随路由切换而变化 */
    margin: 0;
    height: 100%;
    border: 1px solid var(--pv-line, #e6eaf0);
    border-radius: 14px;
    background-color: #ffffff;
    box-shadow: 0 1px 2px rgba(28, 47, 84, 0.05);
    transition:
        box-shadow 0.25s,
        transform 0.25s,
        border-color 0.25s;
}

.doc-card:hover {
    border-color: #d8e1ef;
    box-shadow: 0 14px 30px -16px rgba(28, 47, 84, 0.3);
    transform: translateY(-2px);
}

.doc-card :deep(.el-card__header) {
    padding: 13px 16px;
    border-bottom: 1px solid #eef1f6;
    background: linear-gradient(180deg, #fbfcfe 0%, #ffffff 100%);
}

.doc-card :deep(.el-card__body) {
    padding: 8px;
}

/* ---------- 卡片标题 ---------- */
.doc-card__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    cursor: pointer;
}

.doc-card__name {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.2px;
    color: #1f2d3d;
    transition: color 0.2s;
}

.doc-card__head:hover .doc-card__name {
    color: var(--el-color-primary, #2f6fed);
}

.doc-card__count {
    flex: 0 0 auto;
    padding: 2px 8px;
    border-radius: 999px;
    background-color: var(--el-color-primary-light-9, #eaf1fd);
    color: var(--el-color-primary, #2f6fed);
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
}

/* ---------- 文档列表 ---------- */
.doc-card__list {
    margin: 0;
    padding: 0;
    list-style: none;
}

.doc-card__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 7px 8px;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.doc-card__item:hover {
    background-color: #f6f9ff;
}

.doc-card__title {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    color: #5b6a80;
    transition: color 0.2s;
}

.doc-card__item:hover .doc-card__title {
    color: var(--el-color-primary, #2f6fed);
}

.doc-card__time {
    flex: 0 0 auto;
    font-size: 12px;
    color: #aab4c4;
    white-space: nowrap;
}
</style>
